const AvatarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M12 14V12.6667C12 12.1362 11.7891 11.6277 11.4141 11.2526C11.0859 10.9245 10.6557 10.7219 10.1979 10.6764L10 10.6667H6C5.46956 10.6667 4.96101 10.8775 4.58593 11.2526C4.21086 11.6277 4 12.1362 4 12.6667V14C4 14.3682 3.70152 14.6667 3.33333 14.6667C2.96514 14.6667 2.66666 14.3682 2.66666 14V12.6667C2.66666 11.7826 3.01811 10.935 3.64323 10.3099C4.26835 9.68479 5.11594 9.33334 6 9.33334H10L10.1654 9.33725C10.9892 9.37814 11.7707 9.72387 12.3568 10.3099C12.9819 10.935 13.3333 11.7826 13.3333 12.6667V14C13.3333 14.3682 13.0349 14.6667 12.6667 14.6667C12.2985 14.6667 12 14.3682 12 14Z"
        fill="#313131"
      />
      <path
        d="M10 4.66668C10 3.56211 9.10457 2.66668 8 2.66668C6.89543 2.66668 6 3.56211 6 4.66668C6 5.77125 6.89543 6.66668 8 6.66668C9.10457 6.66668 10 5.77125 10 4.66668ZM11.3333 4.66668C11.3333 6.50763 9.84095 8.00001 8 8.00001C6.15905 8.00001 4.66666 6.50763 4.66666 4.66668C4.66666 2.82573 6.15905 1.33334 8 1.33334C9.84095 1.33334 11.3333 2.82573 11.3333 4.66668Z"
        fill="#313131"
      />
    </svg>
  );
};

export default AvatarIcon;
